module.exports = __webpack_public_path__ + "static/media/bottom_banner_8_2.7aa7ffd3.png";